import React, { Component } from 'react'

import { Nav } from 'react-bootstrap'
import DatePicker from './DatePicker'
import './component_style.css'

import Reports from 'components/Reports'

class NavItem extends Component {
  handleClick = e => {
    if (this.props.disabled) {
      e.preventDefault()
      return
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e)
    }
  }

  render () {
    const {
      children,
      active,
    } = this.props

    return (
      <li role="presentation" className={`${active ? 'active' : ''}`}>
        <a role="button" className="btn btn-sm" onClick={this.handleClick}>
          {children}
        </a>
      </li>
    )
  }
}

export default class Tabs extends Component {
  state = {
    activeKey: this.props.value || '1'
  }

  handleSelect = activeKey => {
    const { onChange } = this.props
    onChange(activeKey)
    this.setState({ activeKey })
  }

  render () {
    const { activeKey } = this.state
    const {
      items = [],
    } = this.props
    return (
      <Nav bsStyle="pills" activeKey={activeKey} onSelect={this.handleSelect}>
        {items.map((item, idx) => (
          <NavItem
            key={idx}
            eventKey={`${idx + 1}`}
          >
            {item.title}
          </NavItem>
        ))}
        <NavItem
          key={items.length + 1}
          eventKey={`${items.length + 1}`}
        >
          <DatePicker
            match={this.props.match}
            onChange={this.props.onChangeDataPicker}
          />
        </NavItem>
        <Reports />
      </Nav>
    )
  }
}
